function chooseOne(options: string[]) {
    return options[Math.floor(Math.random() * options.length)]
}

function makeAttribute(attribute: string, path: string, asset: string) {
    if (asset.length === 0) return attribute + ':None';
    return attribute + ':' + asset.replace(path, '').replaceAll('-', ' ').replace('.png', '');
}

function nonVisualAttribute(attribute: string, options: string[]) {
    return attribute + ':' + chooseOne(options);
}

export function randomizerGods(filenames : string[]) : {images: string[], attributes: string[] } {
    let backAssets = filenames.filter(a => a.startsWith('./Back/'));
    let backgroundAssets = filenames.filter(a => a.startsWith('./Background/'));
    let backgroundPatternAsssets = filenames.filter(a => a.startsWith('./Background-Pattern/'));
    let clothesAssets = filenames.filter(a => a.startsWith('./Clothes/'));
    let faceAssets = filenames.filter(a => a.startsWith('./Face/'));
    let gauntletAssets = filenames.filter(a => a.startsWith('./Gauntlet/'));
    let godAssets = filenames.filter(a => a.startsWith('./God/'));
    let leftShoulderAssets = filenames.filter(a => a.startsWith('./Left-Shoulder/'));
    let rightShoulderAssets = filenames.filter(a => a.startsWith('./Right-Shoulder/'));


    let backAsset = chooseOne(backAssets);
    let backgroundAsset = chooseOne(backgroundAssets);
    let clothesAsset = chooseOne(clothesAssets);
    let faceAsset = chooseOne(faceAssets);
    let gauntletAsset = chooseOne(gauntletAssets);
    let godAsset = chooseOne(godAssets);
    let hairAsset = godAsset.replace('God', 'Hair');
    let handAsset = godAsset.replace('God', 'Hand');
    let backgroundPatternAssset = chooseOne(backgroundPatternAsssets);
    let leftShoulderAsset = chooseOne(leftShoulderAssets);
    let rightShoulderAsset = chooseOne(rightShoulderAssets);

    // custom rules to prevent graphical clashes
    let faceAfterHair = faceAsset.includes("Laser") || faceAsset.includes("Flames")
    if (hairAsset.includes("Loki")) { hairAsset = ""; }

    let assets = faceAfterHair ?
    [backgroundAsset, backgroundPatternAssset, backAsset, godAsset, hairAsset, faceAsset, clothesAsset, handAsset, gauntletAsset, leftShoulderAsset, rightShoulderAsset] :
    [backgroundAsset, backgroundPatternAssset, backAsset, godAsset, faceAsset, hairAsset, clothesAsset, handAsset, gauntletAsset, leftShoulderAsset, rightShoulderAsset];

    assets = assets.filter(asset => asset !== "");

    let images = assets.filter(a => a.length > 0).map(a => '/gods/' + a);

    let demeanors = ['Evil', 'Good', 'Powerful', 'Warlike', 'Peaceful', 'Thoughtful', 'Neutral'];
    let traits = ['Wisdom', 'Fairness', 'Luck', 'Fertility', 'Strength', 'Humility'];
    let powers = ['Volcano', 'Tsunami', 'Fire', 'Flood', 'Locusts', 'Famine'];

    let attributes = [
        makeAttribute('BACKGROUND', './Background/', backgroundAsset),
        makeAttribute('BACK', './Back/', backAsset),
        makeAttribute('CLOTHES', './Clothes/', clothesAsset),
        nonVisualAttribute('DEMEANOR', demeanors),
        makeAttribute('FACE', './Face/', faceAsset),
        makeAttribute('GAUNTLET', './Gauntlet/', gauntletAsset),
        makeAttribute('GOD', './God/', godAsset),
        makeAttribute('PATTERN', './Background-Pattern/', backgroundPatternAssset),
        makeAttribute('Shoulder Left', './Left-Shoulder/', leftShoulderAsset),
        makeAttribute('Shoulder Right', './Right-Shoulder/', rightShoulderAsset),
        nonVisualAttribute('POWER', powers),
        nonVisualAttribute('TRAIT', traits),
    ];

    return {images: images, attributes: attributes};
}
